/**
 * Created by Ethan on 2017/5/12.
 */

import { CACHE_ACCESS_TOKEN, CACHE_SESSION_USER } from "../constants/Profile";
import { message, Modal } from 'antd';
import { HttpStatus } from "../constants/Enums";
import { RoutePath } from "../constants/RoutePath";


var CryptoJS = require('crypto-js')
function decryptData(encryptedData) {
    try {
        const decryptedData = CryptoJS.AES.decrypt(
            encryptedData,
            CryptoJS.enc.Utf8.parse('Reliable2025Cool'),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            }
        ).toString(CryptoJS.enc.Utf8)
        if (decryptedData) {
            let r = JSON.parse(decryptedData)
            // console.log("界面后内容",r)
            return r // 返回解密后的字符串
        } else {
            return null
        }
    } catch (error) {
        console.error('AES 解密错误:', error.message)
        return null
    }
}

const HttpUtils = {

    /*
     * fetch简单封装
     * url: 请求的URL
     * successCallback: 请求成功回调
     * failCallback: 请求失败回调
     *
     * */
    get: (url, successCallback, failCallback) => {
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Auth-Token': localStorage.getItem(CACHE_ACCESS_TOKEN),
            }
        })
            .then((response) => response.json())
            .then((responseJson) => {

                if (responseJson.appId) {
                    return successCallback(responseJson);
                }

                if (responseJson.status === HttpStatus.SUCCESS) {
                    if (
                        url.endsWith('/openAPI/homepage/zone/queryZoneList') ||
                        url.includes('/openAPI/wms/zones/zonesDetail')
                    ) {
                        responseJson.data = decryptData(responseJson.data)
                        console.log(responseJson.data)
                    }
                    successCallback(responseJson);
                } else if (responseJson.status === HttpStatus.LIMIT) {
                    successCallback({
                        ...responseJson,
                        data: {
                            limit: responseJson.msg,
                        }
                    })
                } else {
                    if (responseJson.status === HttpStatus.UNAUTHORIZED) {
                        // if (window.location.href.indexOf("?redirect=") < 0) {
                        //     window.location.href = "/#" + RoutePath.ACCOUNT_USER_LOGIN_PASSWORD.path + "?redirect=" + window.location.href;
                        // }
                        localStorage.removeItem(CACHE_SESSION_USER)
                        localStorage.removeItem(CACHE_ACCESS_TOKEN);
                        window.location.href = `/login?redirect=${encodeURIComponent(window.location.pathname)}`

                    } else if (responseJson.status === HttpStatus.EXCEPTION406) {
                        let message = responseJson.data;
                        switch (message) {
                            case 'ACCOUNT_USER_MSG_DISABLED':
                                message = '登陆被禁用'
                                break;
                            default:
                                message = '登录失败'
                                break;
                        }
                        Modal.error({ title: "ERROR", content: message, okText: "OK" });
                    }
                    else {
                        let message = responseJson.data;

                        message = message.toString();
                        Modal.error({ title: "ERROR", content: message, okText: "OK" });
                        failCallback(responseJson);
                    }
                }
            })
            .catch((error) => {
                message.error("" + error);
            });
    },


    /**
     * 在服务器新建一个资源
     * @param url 服务器资源URL
     * @param params 参数设置
     * @param successCallback 成功返回的方法
     * @param failCallback 失败返回的方法
     */
    post: (url, params, successCallback, failCallback) => {
        HttpUtils.executeFetch("POST", url, params, successCallback, failCallback);
    },

    /**
     * 在服务器更新资源（客户端提供改变后的完整资源）
     * @param url 服务器资源URL
     * @param params 参数设置
     * @param successCallback 成功返回的方法
     * @param failCallback 失败返回的方法
     */
    put: (url, params, successCallback, failCallback) => {
        HttpUtils.executeFetch("PUT", url, params, successCallback, failCallback);
    },

    /**
     * 在服务器删除一个资源
     * @param url 服务器资源URL
     * @param params 参数设置
     * @param successCallback 成功返回的方法
     * @param failCallback 失败返回的方法
     */
    delete: (url, params, successCallback, failCallback) => {
        HttpUtils.executeFetch("DELETE", url, params, successCallback, failCallback);
    },

    executeFetch: (method, url, params, successCallback, failCallback) => {
        fetch(url, {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Auth-Token': localStorage.getItem(CACHE_ACCESS_TOKEN),
            },
            body: JSON.stringify(params)
        })

            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.status === HttpStatus.SUCCESS) {
                    if (
                        url.endsWith('/openAPI/homepage/zone/queryZoneList') ||
                        url.includes('/openAPI/wms/zones/zonesDetail')
                    ) {
                        responseJson.data = decryptData(responseJson.data)
                        console.log(responseJson.data)
                    }
                    successCallback(responseJson);
                } else if (responseJson.status === HttpStatus.LIMIT) {
                    successCallback({
                        ...responseJson,
                        data: {
                            limit: responseJson.msg,
                        }
                    })
                } else {
                    if (responseJson.status === HttpStatus.UNAUTHORIZED) {

                        localStorage.removeItem(CACHE_SESSION_USER)
                        localStorage.removeItem(CACHE_ACCESS_TOKEN);

                        window.location.href = `/login?redirect=${encodeURIComponent(window.location.pathname)}`
                        // if (window.location.href.indexOf("?redirect=") < 0) {
                        //     window.location.href = "/#" + RoutePath.ACCOUNT_USER_LOGIN_PASSWORD.path + "?redirect=" + window.location.href;
                        // }
                    } else if (responseJson.status === HttpStatus.EXCEPTION406) {
                        let message = responseJson.data;
                        switch (message) {
                            case 'ACCOUNT_USER_MSG_DISABLED':
                                message = '登陆被禁用'
                                break;
                            default:
                                message = '登录失败'
                                break;
                        }
                        Modal.error({ title: "ERROR", content: message, okText: "OK" });
                    }
                    else {
                        let message = responseJson.data;
                        if (typeof (message) !== "string") {
                            message = JSON.stringify(message);
                        }
                        Modal.error({ title: "ERROR", content: message, okText: "OK" });
                        failCallback(responseJson);
                    }
                }
            })
            .catch((error) => {
                failCallback(error);
                message.error("" + error);
            });
    },

    getQueryString: (param) => {
        let name, value;
        let query = window.location.href.substring(window.location.href.indexOf("?") + 1);
        let arr = query.split("&");
        for (let i = 0; i < arr.length; i++) {
            let num = arr[i].indexOf("=");
            if (num > 0) {
                name = arr[i].substring(0, num);
                value = arr[i].substr(num + 1);
                if (param === name) {
                    return value;
                }
            }
        }
    },
    getQueryMap: (locationUrl) => {
        let operationUrl = locationUrl ? locationUrl : window.location.href;
        let name, value;
        let query = window.location.href.substring(window.location.href.indexOf("?") + 1);
        let arr = query.split("&");
        let resultMap = {};
        for (let i = 0; i < arr.length; i++) {
            let num = arr[i].indexOf("=");
            if (num > 0) {
                name = arr[i].substring(0, num);
                value = arr[i].substr(num + 1);
                resultMap[name] = value;
            }
        }
        return resultMap;
    },
    // addQueryString: (paramName, paramValue) => {
    //     let url = window.location.href;
    //     if (url.indexOf("?") > 0) {
    //         // 存在参数，则直接加入
    //         url = url + "&" + paramName + "=" + paramValue;
    //     } else {
    //         url = url + "?" + paramName + "=" + paramValue;
    //     }
    //     window.location.href = url;
    // },

    addQueryString: (url, paramName, paramValue) => {
        if (url.indexOf("?") > 0) {
            // 存在参数，则直接加入
            url = url + "&" + paramName + "=" + paramValue;
        } else {
            url = url + "?" + paramName + "=" + paramValue;
        }
        return url;
    },
    addQueryMap: (url, paramMap) => {
        Object.keys(paramMap).forEach(paramName => {
            let paramValue = paramMap[paramName];
            if (url.indexOf("?") > 0) {
                // 存在参数，则直接加入
                url = url + "&" + paramName + "=" + paramValue;
            } else {
                url = url + "?" + paramName + "=" + paramValue;
            }
        });

        return url;
    },

    replaceQueryString: (param, value) => {
        let name, val;
        let query = window.location.href.substring(window.location.href.indexOf("?") + 1);
        let newUrl = window.location.href.substring(0, window.location.href.indexOf("?") + 1);
        let arr = query.split("&");
        let str = [];
        for (let i = 0; i < arr.length; i++) {
            let num = arr[i].indexOf("=");
            if (num > 0) {
                name = arr[i].substring(0, num);
                val = arr[i].substr(num + 1);
                if (param === name) {
                    str.push(name + "=" + value);
                } else {
                    str.push(name + "=" + val);
                }
            }
        }

        window.location.href = newUrl + str.join("&");
    },
    addOrReplaceQueryString: (param, value) => {
        let str = [];
        let name, val, newUrl;
        let isReplace = false;
        if (window.location.href.includes("?")) {
            let query = window.location.href.substring(window.location.href.indexOf("?") + 1);
            newUrl = window.location.href.substring(0, window.location.href.indexOf("?") + 1);
            let arr = query.split("&");
            for (let i = 0; i < arr.length; i++) {
                let num = arr[i].indexOf("=");
                if (num > 0) {
                    name = arr[i].substring(0, num);
                    val = arr[i].substr(num + 1);
                    if (param === name) {
                        str.push(name + "=" + value);
                        isReplace = true;
                    } else {
                        str.push(name + "=" + val);
                    }
                }
            }
        }
        else {
            newUrl = window.location.href + "?";
        }

        if (!isReplace) {
            str.push(param + "=" + value);
        }

        window.location.href = newUrl + str.join("&");
    },
    removeQueryString: (param) => {
        let name, val;
        let query = window.location.href.substring(window.location.href.indexOf("?") + 1);
        let newUrl = window.location.href.substring(0, window.location.href.indexOf("?") + 1);
        let arr = query.split("&");
        let str = arr.filter(item => {
            let num = item.indexOf("=");
            if (num > 0) {
                name = item.substring(0, num);
                return param !== name;
            }
            return true;
        })


        window.location.href = newUrl + str.join("&");
    }
};

export default HttpUtils;